import React, { useEffect, useState } from "react";
import Button from "../../component/Button";
import { useLocation, useNavigate } from "react-router-dom";
import SearchBox from "../../component/SearchBox";
import RetailerList from "./components/retailerList";
import classes from "./style.module.scss";
import GenerateReport from "./components/GenerateReport";
import { useDispatch } from "react-redux";

const RetailerTod = () => {
  const [searchInput, setSearchInput] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [generateReport, setGenerateReport] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const COMPLETED_REPORT = 'Completed Reports'
  const IN_PROGRESS = 'In-Progress Reports'
  const productList = [COMPLETED_REPORT, IN_PROGRESS];
  const [activeTab, setActiveTab] = useState(COMPLETED_REPORT)


  useEffect(() => {
    if (location?.pathname) {
      const pathName = location?.search?.split('?type=')
      const params = pathName[pathName?.length - 1]
      if (params) {
        setGenerateReport(true)
      } else {
        setGenerateReport(false)
      }
    }
  }, [location])


  const redirectTo = () => {
    navigate(`?type=generate`);
  };

  const handleSearchChange = (value) => {
    setSearchInput(value);
  };

  return (
    <>
      {generateReport ?
        <GenerateReport /> :
        <div className={`${classes.loyaltyProgramWrapper}`}>
          <div className={`w-[100%] flex items-center justify-between`}>
            <div className={`layout-title`}>Retailer TOD</div>
            <div className="flex items-center gap-4">
            <SearchBox value={searchInput} onChange={handleSearchChange} placeholder={'Find by Report Name'} />
              <Button
                text={"Generate Report"}
                className={"!px-4"}
                smallBtn
                onClick={() => { redirectTo() }}
              />
            </div>
          </div>
          <div className={`${classes.headerList} w-[100%] flex items-center`}>
            {productList?.map((title) => <div className={`${classes.headerTab} ${activeTab === title ? classes.activeTab : ''}`} onClick={() => setActiveTab(title)}>{title}</div>)}
          </div>
          <div>
            <RetailerList
              isLoading={isLoading}
              setisLoading={setisLoading}
              value={searchInput}
              active={activeTab}
            />
          </div>
        </div>}

    </>
  );
};

export default RetailerTod;
